import React, { useState,useContext } from 'react';
import './base1.css';
import { Outlet, useNavigate,useLocation } from 'react-router-dom';
import cartContext from '../Context/cartContext';
import wishlistContext from '../wishlistContent/wishlistContent'
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import {userContex} from "../../App"

export default function Header() {
    const a = JSON.parse(localStorage.getItem('user'));
    const {isLogin,setIsLogin} = useContext(userContex);
    const [cart, setCart] = useState([]);
    const [wishlist, setWishlist] = useState([]);
    const [showMenu,setShowMenu] = useState(false);
    const navigate = useNavigate();

    return (
        <cartContext.Provider value={{ cart, setCart }}>
            <wishlistContext.Provider value={{ wishlist, setWishlist }}>
                    <div className='Header'>
                        {
                            showMenu?<CloseIcon className='close__icon' onClick={()=>{setShowMenu(false)}}/>:<MenuIcon className='menu__icon'onClick={()=>{setShowMenu(true)}}/>
                        }
                        
                        <img width="130px" className='headerName' onClick={()=>{ navigate('/')}} src="https://assets.ajio.com/static/img/Ajio-Logo.svg" alt="" />
                        <ul className='headerNavigation' >
                            <li onClick={() => {
                                navigate('/')
                                setShowMenu(false)
                            }} className='headerLink'>HOME</li>
                            <li onClick={() => {
                                navigate('/men')
                                setShowMenu(false)
                            }} className='headerLink'>MEN</li>
                            <li onClick={() => {
                                navigate('/women')
                                setShowMenu(false)
                            }} className='headerLink'>WOMEN</li>
                            <li onClick={() => {
                                navigate('/kids')
                                setShowMenu(false)
                            }} className='headerLink'> KIDS</li>
                            <li onClick={() => {
                                navigate('/cart')
                                setShowMenu(false)
                            }} className='headerLink'><i class="fa-solid fa-bag-shopping bag"></i></li>
                            <li onClick={() => {
                                navigate('/wishlist')
                                setShowMenu(false)
                            }} className='headerLink'><i class="fa-sharp fa-solid fa-heart bag"></i></li>
                            <li onClick={() => {
                                navigate('/login')
                                setShowMenu(false);
                                setIsLogin("");
                                localStorage.removeItem("islogin")
                                localStorage.removeItem("user")
                            }} className='headerLink logout'>{isLogin == 'yes' ? `${a.name}/Signout` : 'LOGIN'}</li>
                        </ul>
                    </div>
                    <div className='mainValue'>
                        <Outlet></Outlet>
                    </div>
                    <div>

                    </div>
            </wishlistContext.Provider>
        </cartContext.Provider >

    )
}